import React from 'react';
import { routes } from 'app/routing/routesConfig';
import { SongStatusType } from 'types/song';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { PlaylistCover } from 'app/components/Song/PlaylistCover';
import { SongCover } from '../../Song/SongCover';
import { audioPlayerDetailsSx } from './styles';

interface AudioPlayerDetailsProps {
  songTitle?: string;
  songGuid?: string;
  songStatus?: SongStatusType | null;
  audioTitle?: string;
  isPlaylistMode?: boolean;
  image?: string;
}

export const AudioPlayerDetails = ({
  songTitle,
  songGuid,
  songStatus,
  audioTitle,
  isPlaylistMode,
  image,
}: AudioPlayerDetailsProps) => {
  const styles = audioPlayerDetailsSx();

  return (
    <Box sx={styles.details}>
      {songStatus && !isPlaylistMode && (
        <SongCover size="38" status={songStatus} sx={{ mr: 2 }} />
      )}
      {isPlaylistMode && (
        <PlaylistCover color="P.40" size="small" mr={2} image={image} />
      )}
      <Flex direction="column" w="full" overflow="hidden">
        <Text
          data-testid="audio-title"
          textOverflow="ellipsis"
          overflow="hidden"
        >
          {audioTitle || 'Loading...'}
        </Text>
        {songGuid ? (
          <Link
            data-testid="song-title"
            as={RouterLink}
            to={routes.song.path.replace(':guid', songGuid || '')}
            sx={styles.songTitle}
          >
            {songTitle}
          </Link>
        ) : null}
      </Flex>
    </Box>
  );
};
